import { toast, ToastOptions } from 'react-toastify'

const DEFAULT_TOAST_OPTIONS: ToastOptions = {
  autoClose: 5000,
  closeOnClick: true,
  draggable: true,
  hideProgressBar: false,
  pauseOnHover: true,
  position: 'top-right',
  theme: 'light'
}

export const showToast = (message: string, options?: ToastOptions) => {
  toast(message || 'Success', options || DEFAULT_TOAST_OPTIONS)
}

// A non-error notice: the main action succeeded but a secondary step did not.
export const showWarningToast = (message: string) => {
  toast.warning(message, DEFAULT_TOAST_OPTIONS)
}
